<template src='./VerTarjetaMiniatura.html'>
    
</template>
<script>
import { serverBus } from '../../main'
export default {
    data() {
        return { 
        }
    },
    props: {
        formulariosLlenosTipoMomento:{
            type: Array,
            required: true
        }
    },
    methods: {
        abrirTarjetaFormularioMomento(formulario_id, nombreCategoria,valor, coleccion) {
            this.$store.dispatch("setIdFormularioOverlay", formulario_id);
            serverBus.$emit("abrirTarjetaFormularioOverlay", formulario_id, nombreCategoria,valor, coleccion); 
        } 
    },
}
</script>
<style lang="scss" src='./VerTarjetaMiniatura.scss' scoped>

</style>



// WEBPACK FOOTER //
// src/components/VerTarjetaMiniatura/VerTarjetaMiniatura.vue